<agr-dialog [data]="data" (alt)="saveAndNextWeek()" (cancel)="cancel()" (confirm)="save()">
  <div class="spacing--margin-horizontal layer-summary">
    <div class="spacing--margin-bottom">
      <div class="layer-summary__grid">
        <div class="flex--column layer-summary__item">
          <span class="text--small text--gray label">
            {{ 'week-registration.period' | translate }}
          </span>
          <span class="text--small text--bold label">
            {{ firstDayOfWeek() | agrDate }} -<br />{{ lastDayOfWeek() | agrDate }}
          </span>
        </div>
        <div
          *ngIf="amountOfHensStartOfWeekValue() !== undefined"
          class="flex--column layer-summary__item"
        >
          <span class="text--small text--gray label">
            {{ 'week-registration.amountOfHensStartOfWeek' | translate }}
            {{ currentWeekRegistrationValue().weekNr }}
          </span>
          <span
            class="text--small text--bold label"
            data-test="week-registration__amountOfHensStartOfWeek"
          >
            {{ amountOfHensStartOfWeekValue() }}
          </span>
        </div>
        <div class="flex--column layer-summary__item">
          <span class="text--small text--gray label">
            {{ 'week-registration.amountOfHensStartOfFlock' | translate }}
          </span>
          <span
            class="text--small text--bold label"
            data-test="week-registration__amountOfHensStartOfFlock"
          >
            {{ data.flock.arrival.amountOfHens }}
          </span>
        </div>
        <div class="flex--column layer-summary__item">
          <span class="text--small text--gray label">
            {{ 'week-registration.breed' | translate }}
          </span>
          <span class="text--small text--bold label">
            {{ data.flock.arrival.breed?.name }}
          </span>
        </div>
        <div class="flex--column layer-summary__item">
          <span class="text--small text--gray label">
            {{ 'week-registration.barn' | translate }}
          </span>
          <span class="text--small text--bold label">
            {{ data.flock.arrival.barn?.name }}
          </span>
        </div>
        <div class="flex--column layer-summary__item">
          <span class="text--small text--gray label">
            {{ 'week-registration.dateOfBirth' | translate }}
          </span>
          <span class="text--small text--bold label">
            {{ data.flock.arrival.chickBirthDate | agrDate }}
          </span>
        </div>
        <div class="flex--column layer-summary__item">
          <span class="text--small text--gray label">
            {{ 'week-registration.arrivalDate' | translate }}
          </span>
          <span class="text--small text--bold label">
            {{ data.flock.arrival.arrivalDate | agrDate }}
          </span>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="hasFormGroups()" class="flex--row">
    <!-- Show when daily or dynamic values are defined. -->
    <mat-tab-group
      [mat-stretch-tabs]="false"
      *ngIf="!isWeeklyInputMethod()"
      animationDuration="0"
      [selectedIndex]="selectedTabIndexValue()"
      (selectedIndexChange)="onSelectedTabIndexChange($event)"
      color="accent"
      class="weekRegistrationTabs"
    >
      <mat-tab
        *ngFor="let tab of tabsValue(); let i = index"
        [label]="tab?.name"
        class="week-registration-tab"
      >
        <app-week-registration-form
          data-test="week-registration__dailyView"
          class="flex__child--auto"
          [formGroup]="formGroupsValue()[i]"
          [showFields]="tab.showFields"
          [inputMethod]="tab.inputMethod"
          [amountOfHens]="amountOfHensPerTab()[i]"
          [selectedForageProductsAndMoult]="lastForageProductsAndMoult()"
          [index]="i"
          [isEditMode]="isEditMode"
          (forageProductChangedEvent)="forageProductForDayChanged($event)"
          (isInMoultChangedEvent)="isInMoultChanged($event)"
          (isSecondForageChangedEvent)="onIsSecondForageChanged($event)"
          (mortalityChangedEvent)="mortalityForDayChanged($event)"
        >
        </app-week-registration-form>
      </mat-tab>
    </mat-tab-group>

    <!-- Show when only weekly data is defined. -->
    <ng-container *ngIf="isWeeklyInputMethod()">
      <app-week-registration-form
        *ngFor="let formGroup of weeklyFormGroups(); trackBy: trackFormGroup"
        data-test="week-registration__weeklyView"
        class="flex__child--auto"
        [formGroup]="formGroup"
        [showFields]="allShowFields()"
        [inputMethod]="inputMethods.PerWeek"
        [amountOfHens]="amountOfHensStartOfWeekValue()"
        [selectedForageProductsAndMoult]="lastForageProductsAndMoult()"
        [index]="0"
        [isEditMode]="isEditMode"
        (forageProductChangedEvent)="forageProductForDayChanged($event)"
        (isInMoultChangedEvent)="isInMoultChanged($event)"
        (mortalityChangedEvent)="mortalityForDayChanged($event)"
      >
      </app-week-registration-form>
    </ng-container>
  </div>
</agr-dialog>
